import React from 'react';
import { Routes, Route, Navigate, Outlet, useLocation } from 'react-router-dom';
import AppToaster from './components/ui/AppToaster';
import Layout from './components/layout/Layout';
import { useAuth } from './contexts/AuthContext';

import LoginPage from './pages/auth/LoginPage';
import Dashboard from './pages/Dashboard';

import CoursesPage from './pages/courses/CoursesPage';
import GroupsPage from './pages/groups/GroupsPage';
import StudentsPage from './pages/students/StudentsPage';
import TrainersPage from './pages/trainers/TrainersPage';
import CertificationsPage from './pages/certifications/CertificationsPage';
import SchedulePage from './pages/schedule/SchedulePage';
import ClassroomsPage from './pages/classrooms/ClassroomsPage';
import PaymentsPage from './pages/payments/PaymentsPage';

import BenefitsPage from './pages/benefits/BenefitsPage';
import ReportsPage from './pages/reports/ReportsPage';
import EvaluationsPage from './pages/evaluations/EvaluationsPage';
import SettingsPage from './pages/settings/SettingsPage';

function ProtectedRoutes() {
  const { isAuthenticated, loading, sessionChecked } = useAuth();
  const location = useLocation();

  if (loading || !sessionChecked) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-100 dark:bg-slate-950">
        <p className="text-sm text-slate-600 dark:text-slate-400">Chargement…</p>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <Outlet />;
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/login" element={<LoginPage />} />

        <Route element={<ProtectedRoutes />}>
          <Route element={<Layout />}>
            <Route index element={<Navigate to="/dashboard" replace />} />
            <Route path="dashboard" element={<Dashboard />} />
            <Route path="courses/*" element={<CoursesPage />} />
            <Route path="groups/*" element={<GroupsPage />} />
            <Route path="students/*" element={<StudentsPage />} />
            <Route path="trainers/*" element={<TrainersPage />} />
            <Route path="sessions/*" element={<Navigate to="/groups" replace />} />
            <Route path="certifications/*" element={<CertificationsPage />} />
            <Route path="evaluations/*" element={<EvaluationsPage />} />
            <Route path="schedule/*" element={<SchedulePage />} />
            <Route path="classrooms/*" element={<ClassroomsPage />} />
            <Route path="payments/*" element={<PaymentsPage />} />
            <Route path="benefits/*" element={<BenefitsPage />} />
            <Route path="reports/*" element={<ReportsPage />} />
            <Route path="settings/*" element={<SettingsPage />} />
          </Route>
        </Route>
      </Routes>
      <AppToaster />
    </>
  );
}

export default App;
